export const SEARCH_TITS_DEFAULT_LENGTH = 5
